export default __webpack_public_path__ + "media/images/user_photos/101-05ceae2b2b4522318bd2731d3eed9040.jpg";